import get from 'lodash/get'

export const maintenanceSelector = state => {
  const { maintenance } = state
  return get(maintenance, 'maintenance.enabled', false)
}
